module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Cart#3-55aa0d1324d6a695c0c94862ab7d464c.svg";